

import {CaseReducer} from '@reduxjs/toolkit'
import {
    NinchatQueueJoinedEvent,
} from '../types/events'
import {NinchatState} from 'api/types'

import {
    extractProperties,
} from '.'

export const queueJoined: CaseReducer<NinchatState> = (state, action) => {
    const {
        queue_id,
        queue_attrs,
        realm_id,
        queue_settings,
    } = extractProperties<NinchatQueueJoinedEvent>(action.payload)
    // When i have joined new queue

    const myUserId = state.user_id || ''

    state.user_queues = {
        ...state.user_queues,
        [queue_id]: {
            queue_attrs,
            queue_members: {
                // eslint-disable-next-line no-extra-parens
                ...(state._queues?.[queue_id]?.queue_members || {}),
                [myUserId]: {
                    member_attrs: {},
                    user_attrs: state._users?.[myUserId]?.user_attrs,
                },
            },
            queue_settings,
            realm_id,
        },
    }

    if (state._queues?.[queue_id]) {
        delete state._queues[queue_id]
    }
}

